import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { useAuthContext } from "../contexts/AuthContext";

/**
 * The client id to send with node option requests.
 *
 * Client-admin users are scoped server-side, so the id is omitted for them; admin users pass the
 * selected client.
 */
export const useOptionsClientId = () => {
  const { activeUser } = useAuthContext();
  const { selectedClient } = useContext(AppContext);

  const isClientUser = Boolean(String(activeUser?.user_type ?? "").match(/client/i));

  return isClientUser ? null : selectedClient?.public_id ?? selectedClient?.id ?? null;
};

export default useOptionsClientId;
